import {
  Directive,
  OnDestroy,
  OnInit,
}                    from '@angular/core';
import { NgControl } from '@angular/forms';
import {
  distinctUntilChanged,
  Subject,
  takeUntil,
}                    from 'rxjs';

@Directive({
  selector: '[rbDigitsOnly]',
  standalone: true,
})
export class DigitsOnlyDirective implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();

  constructor(private readonly ngControl: NgControl) {
  }

  ngOnInit() {
    this.ngControl.valueChanges?.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged(),
    ).subscribe(value => this.keepDigitsOnly(value));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private keepDigitsOnly(value: unknown) {
    if (typeof value !== 'string') {
      return;
    }
    const digitsOnlyValue = value.replace(/\D/g, '');
    if (digitsOnlyValue !== value) {
      this.ngControl.control?.setValue(digitsOnlyValue);
    }
  }
}
